/**
 * Created by comoon on 2/27/16.
 */


var Enjoy = {
    code: 0,
    name: "品质旅行",
    prefix: "品质"
};

var Luxury = {
    code: 1,
    name: "优选旅行",
    prefix: "优选"
};

module.exports = {
    Enjoy,
    Luxury,
    list: [Enjoy, Luxury]
};


/** WEBPACK FOOTER **
 ** ./script/conf/trip-grade.js
 **/